export const isDomainValid = (input: string): boolean => {
  if (typeof input !== 'string') return false;

  // trim 후 소문자로 변환
  const domain = input.trim().toLowerCase();
  if (domain.length === 0) return true; // 빈 문자열은 허용

  // domain 에 허용되지 않는 문자 차단
  const badChars = [
    ' ',
    '/',
    '\\',
    ':',
    '@',
    '?',
    '#',
    ',',
    ';',
    '"',
    "'",
    '(',
    ')',
    '[',
    ']',
    '{',
    '}',
    '<',
    '>',
    '|',
    '·',
    '…'
  ];
  for (const ch of badChars) if (domain.includes(ch)) return false;

  // 전체 길이 제한
  if (domain.length > 253) return false;

  // 라벨 분해 및 개수 확인
  if (domain.startsWith('.') || domain.endsWith('.')) return false;
  if (domain.includes('..')) return false;

  const labels = domain.split('.');
  if (labels.length < 2) return false; // 최소 2라벨 (예: google.com)

  // 각 라벨 검증
  for (const label of labels) {
    if (!isValidLabel(label)) return false;
  }

  // TLD 규칙: 길이 ≥ 2, 전부 숫자면 불허
  const tld = labels[labels.length - 1];
  if (tld.length < 2) return false;
  if (isAllDigits(tld)) return false;

  return true;
};

// 라벨: 1~63, a-z / 0-9 / '-' 만 허용, 앞뒤 '-' 금지
const isValidLabel = (label: string): boolean => {
  if (label.length === 0 || label.length > 63) return false;
  if (label.startsWith('-') || label.endsWith('-')) return false;

  for (let i = 0; i < label.length; i++) {
    const c = label.charCodeAt(i);
    const isLower = c >= 97 && c <= 122; // a-z
    const isDigit = c >= 48 && c <= 57; // 0-9
    const isHyphen = c === 45; // '-'
    if (!isLower && !isDigit && !isHyphen) return false;
  }
  return true;
};

const isAllDigits = (s: string): boolean => {
  if (s.length === 0) return false;
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    if (c < 48 || c > 57) return false;
  }
  return true;
};
